import React from "react";

import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { ConsignmentModal } from "components/ConsignmentBobbyCalf";

import { SaleRoundName } from "constants/sale";

import {
  getNextAvailableAuctionPen,
  getSaleRoundIdByName,
  getNestedConsignments,
  selectScansBySaleLotIdLookup,
  getUnsoldDefaultBobbyCalfSaleLots,
  currentSaleSelector,
} from "selectors";

const BobbyCalfConsignment = () => {
  const history = useHistory();
  const { consignmentId } = useParams();

  const consignments = useSelector(getNestedConsignments);
  const selectedSale = useSelector(currentSaleSelector);
  const nextAvailableAuctionPen = useSelector(getNextAvailableAuctionPen);
  const saleRoundId = useSelector(state =>
    getSaleRoundIdByName(state, SaleRoundName.BobbyCalf),
  );
  const scans = useSelector(selectScansBySaleLotIdLookup);
  const unsoldSaleLots = useSelector(getUnsoldDefaultBobbyCalfSaleLots);

  let consignmentToEdit = consignments.find(c => c.id === consignmentId);
  if (consignmentToEdit && consignmentToEdit.attachments.length) {
    const file = consignmentToEdit.attachments[0];
    consignmentToEdit = { ...consignmentToEdit, fileAttachment: file };
  }

  const existingAuctionPenId =
    unsoldSaleLots.length > 0 ? unsoldSaleLots[0].auctionPenId : null;

  return (
    <ConsignmentModal
      closeSelf={history.goBack}
      consignments={consignments}
      consignmentToEdit={consignmentToEdit}
      selectedSale={selectedSale}
      existingAuctionPenId={existingAuctionPenId}
      nextAvailableAuctionPen={nextAvailableAuctionPen}
      saleRoundId={saleRoundId}
      scans={scans}
    />
  );
};

export default BobbyCalfConsignment;
